import type { OrderDetails } from '@/entities/order/model'
import { Box, Divider, Group, Paper, Text } from '@mantine/core'
import { Fragment } from 'react'
import classes from './HsFieldsTable.module.css'

interface HsFieldsTableProps {
  hsFields: OrderDetails['hsFields']
  variant: 'desktop' | 'mobile'
}

export function HsFieldsTable({ hsFields, variant }: HsFieldsTableProps) {
  if (!hsFields)
    return null

  const entries = Object.entries(hsFields).filter(
    ([key]) => key.toLowerCase() !== 'restricted',
  )

  if (entries.length === 0)
    return null

  return (
    <Paper className={variant === 'desktop' ? classes.cardDesktop : classes.cardMobile}>
      <Group justify="space-between" p="md" bg="gray.9" className={classes.header}>
        <Text span className={classes.headerText}>Order details</Text>
      </Group>

      <Box p="lg" className={variant === 'desktop' ? classes.scrollableBody : undefined}>
        {entries.map(([key, value], index) => (
          <Fragment key={key}>
            <div className={classes.row}>
              <Text span className={classes.rowKey}>{key}</Text>
              <Text span className={classes.rowValue}>{value}</Text>
            </div>
            {index < entries.length - 1 && <Divider variant="dashed" my="sm" />}
          </Fragment>
        ))}
      </Box>
    </Paper>
  )
}
